import { Math as WordMath, MathFraction, MathRadical, MathRun, MathSubScript, MathSuperScript, TextRun } from 'docx';
import { parseMathText } from './mathNotation';

function equationNodes(nodes) {
    return nodes.flatMap((node) => {
        switch (node.type) {
            case 'fraction': return [new MathFraction({ numerator: equationNodes(node.numerator), denominator: equationNodes(node.denominator) })];
            case 'root': return [new MathRadical({ children: equationNodes(node.children) })];
            case 'superscript': return [new MathSuperScript({ children: equationNodes(node.children), superScript: equationNodes(node.script) })];
            case 'subscript': return [new MathSubScript({ children: equationNodes(node.children), subScript: equationNodes(node.script) })];
            case 'group': return equationNodes(node.children);
            default: return [new MathRun(node.text)];
        }
    });
}

export function mathTextRuns(value, options = {}) {
    return String(value ?? '').split(/\r?\n/).flatMap((line, index) => [
        ...(index ? [new TextRun({ break: 1 })] : []),
        ...parseMathText(line).map((segment) => segment.type === 'math'
            ? new WordMath({ children: equationNodes(segment.nodes) })
            : new TextRun({ ...options, text: segment.text }))
    ]);
}
